import { companiesDocumentsTranslations as companiesDocumentsTranslationsEn } from '@I18n/en/companies/documents';

export const companiesDocumentsTranslations = {
  button: 'Déposer un document',
  empty: "Cette entreprise n'a aucun document",
  create: {
    title: "Déposer un document d'entreprise",
    success: 'Document téléchargé',
    failure: 'Erreur lors du téléchargement du document : %{error}',
    label: 'Télécharger Document',
  },
  title: 'Documents',
  sections: {
    details: 'Détails du document',
  },
  fields: {
    document_url: 'Url',
    created_at: 'Créé le',
    is_archived: 'Archivé',
    document_comment: 'Notes',
    id: 'ID du document',
    company_id: "ID de l'entreprise",
    document_name: 'Nom',
    updated_at: 'Mis à jour le',
    source: 'Source',
  },
} satisfies typeof companiesDocumentsTranslationsEn;
